import { render, staticRenderFns } from "./HotelDescriptionImportant.vue?vue&type=template&id=5369c18f&"
import script from "./HotelDescriptionImportant.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescriptionImportant.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelDescriptionImportant.vue?vue&type=style&index=0&id=5369c18f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports